/* ENLIY AirPresso – Landingpage: Einblend-Animation + Sticky-Kaufleiste.
   Warenkorb, Cart Drawer und FAQ laufen ueber ap-theme.js (nur Layout "airpresso").
   Phase 1: Auf dem Smartphone erscheint die Kaufleiste sofort, solange der Haupt-Button noch unter dem sichtbaren Bereich liegt. */
(function () {
  'use strict';
  if (window.__lpInit) return;
  window.__lpInit = true;

  var revealEls = [];
  var bar, btn, finalEl;

  function vh() { return window.innerHeight || document.documentElement.clientHeight || 800; }
  function isPhone() { return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches); }

  function revealCheck() {
    if (!revealEls.length) return;
    var h = vh();
    revealEls = revealEls.filter(function (el) {
      if (el.getBoundingClientRect().top < h * 0.94) { el.classList.add('is-in'); return false; }
      return true;
    });
  }

  function stickyCheck() {
    if (!bar || !btn) return;
    var h = vh();
    var r = btn.getBoundingClientRect();
    var pastBtn = r.bottom < 0;
    var belowFold = isPhone() && r.top > h - 8;
    var atFinal = false;
    if (finalEl) {
      var fr = finalEl.getBoundingClientRect();
      atFinal = fr.top < h * 0.85 && fr.bottom > 0;
    }
    var show = (pastBtn || belowFold) && !atFinal;
    if (bar.classList.contains('is-visible') !== show) {
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }
  }

  var last = 0, pending = null;
  function onScroll() {
    var now = Date.now();
    if (now - last > 80) { last = now; revealCheck(); stickyCheck(); }
    clearTimeout(pending);
    pending = setTimeout(function () { revealCheck(); stickyCheck(); }, 100);
  }

  function errorWatcher() {
    var err = document.querySelector('#lp-buy-form [data-ap-add-error]');
    if (!err || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      if (!err.hasAttribute('hidden')) err.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }).observe(err, { attributes: true, attributeFilter: ['hidden'] });
  }

  function init() {
    revealEls = Array.prototype.slice.call(document.querySelectorAll('.lp-reveal:not(.is-in)'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { revealEls.forEach(function (el) { el.classList.add('is-in'); }); revealEls = []; }
    else { revealCheck(); document.documentElement.classList.add('lp-js'); }
    bar = document.querySelector('[data-lp-sticky]');
    btn = document.querySelector('#lp-buy-form [data-ap-add-button]') || document.getElementById('lp-buy-form');
    finalEl = document.querySelector('[data-lp-final]');
    stickyCheck();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    errorWatcher();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () {
    Array.prototype.forEach.call(document.querySelectorAll('.lp-reveal'), function (el) { el.classList.add('is-in'); });
  });
})();